import type { UserCompany } from '../services/auth.service';
import {
  findPrimaryUserCompany,
  getUserCompanyId,
  getVisibleUserCompanies,
} from './studies-company.util';

export const PERSONAL_ORGANIZATION_ID =
  '27a8906a-a8ab-415f-9128-029901816a91';

export const PROFESSIONAL_ORGANIZATION_ID =
  '27a8906a-a8ab-415f-9128-029901816a92';

const RESERVED_ORG_NAMES = new Set(['personal', 'professional']);

export function isReservedAccountOrganization(
  userCompany: UserCompany
): boolean {
  const companyId = getUserCompanyId(userCompany)?.toLowerCase();
  if (companyId === PERSONAL_ORGANIZATION_ID.toLowerCase()) {
    return true;
  }
  if (companyId === PROFESSIONAL_ORGANIZATION_ID.toLowerCase()) {
    return true;
  }
  const name = (
    userCompany.companyName ||
    userCompany.company?.name ||
    ''
  )
    .trim()
    .toLowerCase();
  return RESERVED_ORG_NAMES.has(name);
}

export function getWorkplaceUserCompanies(
  userCompanies: UserCompany[] | null | undefined
): UserCompany[] {
  return getVisibleUserCompanies(userCompanies).filter(
    (uc) => !isReservedAccountOrganization(uc)
  );
}

export function hasPrimaryWorkplaceOrganization(
  userCompanies: UserCompany[] | null | undefined
): boolean {
  return !!findPrimaryUserCompany(userCompanies);
}
